/** FEAT-085 — persisted Faces/Cards toggle for caregiver discovery surfaces. */
export type DiscoveryViewMode = 'faces' | 'cards';

export const DISCOVERY_VIEW_MODE_STORAGE_KEY = 'careva:discovery-view-mode';

export const DEFAULT_DISCOVERY_VIEW_MODE: DiscoveryViewMode = 'faces';

export function parseDiscoveryViewMode(value: string | null): DiscoveryViewMode {
  if (value === 'faces' || value === 'cards') {
    return value;
  }
  return DEFAULT_DISCOVERY_VIEW_MODE;
}
